import { AxiosError } from 'axios';
import { GET_CHECK_REGISTRATION_STATUS } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { GET_RESIT_CHECK_REGISTRATION_STATUS } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: boolean | null) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  enabled: boolean;
  refetchInterval?: number;
}

export const useGetCheckRegistrationStatus = ({
  uuid,
  onSuccess,
  onError,
  enabled,
  refetchInterval = 5000,
}: Input) => {
  const getCheckRegistrationStatus = async () => {
    const res = await axiosClient.get<boolean | null>(GET_CHECK_REGISTRATION_STATUS(uuid));
    return res.data;
  };

  return useCustomQuery(GET_RESIT_CHECK_REGISTRATION_STATUS, getCheckRegistrationStatus, {
    onSuccess,
    onError,
    enabled,
    refetchInterval,
  });
};
